var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 180,
    viewBox: "0 0 188 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18234_94781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.875 46.736C129.494 46.736 132.428 43.7979 132.428 40.1735C132.428 36.5491 129.494 33.611 125.875 33.611C122.256 33.611 119.322 36.5491 119.322 40.1735C119.322 43.7979 122.256 46.736 125.875 46.736Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8021 127.984C34.6755 127.984 40.2475 122.404 40.2475 115.521C40.2475 108.638 34.6755 103.058 27.8021 103.058C20.9288 103.058 15.3568 108.638 15.3568 115.521C15.3568 122.404 20.9288 127.984 27.8021 127.984Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8085 107.701C44.5912 107.911 46.399 108.011 48.2319 108.011C56.2581 108.011 63.8157 106.008 70.4275 102.463",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.592 99.7558C9.21362 91.2488 1.08691 76.9756 1.08691 60.7997C1.08691 34.7257 22.1946 13.5881 48.2318 13.5881C55.3458 13.5881 62.0916 15.1638 68.1427 17.9967",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6093 92.2713C15.3819 85.2394 8.66962 73.447 8.66962 60.0873C8.66962 38.5475 26.1115 21.0809 47.6209 21.0809C53.4962 21.0809 59.0702 22.38 64.0751 24.7268",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2888 50.6919C95.0002 53.9438 95.3684 57.3298 95.3684 60.7997C95.3684 62.8531 95.2345 64.873 94.9834 66.8509",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4844 47.1551C51.362 55.4274 48.0226 61.948 48.0226 61.948C37.2093 50.8009 30.0032 47.7921 30.0032 47.7921L19.1649 59.5929C19.1649 59.5929 32.6396 68.5524 42.3732 78.0232C46.3069 81.8535 52.7011 81.3338 55.8982 76.8666C68.0255 59.9281 83.4085 39.3521 108.985 32.0772C108.985 32.4627 102.725 17.6279 102.725 17.6279C88.1623 22.1622 76.7381 29.7053 68.1762 37.2987",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.211 138.251L60.8864 166.194C57.639 167.082 54.2913 165.163 53.4041 161.911L51.9478 156.581C51.0607 153.329 52.9773 149.976 56.2246 149.088L169.998 118.019",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.641 114.289L186.695 125.511C187.583 128.763 185.666 132.116 182.419 133.004L174.936 135.049",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7842 143.196L75.558 81.5517C75.4575 78.7188 77.3155 76.1877 80.044 75.4418L173.823 49.837C177.615 48.8061 181.372 51.5719 181.515 55.5028L183.641 114.289",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.439 112.235C132.004 112.235 138.948 103.62 138.948 92.9921C138.948 82.3643 132.004 73.7488 123.439 73.7488C114.874 73.7488 107.931 82.3643 107.931 92.9921C107.931 103.62 114.874 112.235 123.439 112.235Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.869 108.984C149.585 108.657 158.248 111.037 164.006 115.513",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7744 133.867C99.4694 127.087 105.73 120.633 114.266 115.974",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.951 59.0061L173.731 54.9747L174.936 88.5416",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.668 129.878V166.412",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.913 148.141H150.431",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7816 119.611V136.348",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1427 127.975H51.429",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.651 33.6193C173.606 22.1622 183.716 22.7405 183.716 22.7405",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.196 40.5087C179.473 35.1949 184.645 37.9105 184.645 37.9105",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18234_94781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187.5,
    height: 154.5,
    fill: "white",
    transform: "translate(0.25 12.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyId);
export default __webpack_public_path__ + "static/media/verifyId.fdc126c80ddf60b15b908e5cd7d1165e.svg";
export { ForwardRef as ReactComponent };